import { createDecorator } from '../../instantiation/common/registry.js';
import type { LongFrameLike } from '../../../base/browser/longAnimationFrame.js';

export const ITracingService = createDecorator<ITracingService>('tracingService');
export interface ITraceSpan {
    end(outcome: 'success' | 'failed'): void;
}
export interface ITracingService {
    /** Use stable operation names, never user content or arguments. Measures elapsed time, including awaits. */
    startSpan(name: string): ITraceSpan;
    /** Page-wide timing; overlap with editor work does not establish causation. */
    recordLongFrame(frame: LongFrameLike): void;
}
